import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2 },
  { title: 'Assessor', flex: 2 },
  { title: 'Valor disp.' },
  { title: 'Valor total' },
];

export const getCheckingAccountFilters = (): FilterModalTypes.FilterType[] => [
  {
    type: 'range',
    fieldName: 'availableValue',
    labelType: 'money',
    title: 'Valor disponível',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'totalValue',
    labelType: 'money',
    title: 'Valor total',
    min: 0,
    max: 1000000000,
  },
];
